import { Routes, Route } from "react-router-dom";
import "./App.css";
import Navbar from "./componets/header/Navbar";
import Section from "./componets/pages/Section1";
import AboutUs from "./componets/pages/AboutUs";
import ContactUs from "./componets/pages/ContactUs";
import PrivacyPolicy from "./componets/pages/PrivacyPolicy";
import TermsConditions from "./componets/pages/TermsConditions";
import Footer from "./componets/footer/Footer";
import NursePractitioners from "./componets/pages/services/NursePractitioners";
import MentalHealth from "./componets/pages/services/MentalHealth";
import Chiro from "./componets/pages/services/Chiro";
import FamilyMedicine from "./componets/pages/services/FamilyMedicine";
import InternalMedicine from "./componets/pages/services/InternalMedicine";
import PT from "./componets/pages/services/PT";
import AccountsReceivable from "./componets/pages/industries/AccountsReceivable";
import DenialManagement from "./componets/pages/industries/DenialManagement";
import ChargeEntryAudit from "./componets/pages/industries/ChargeEntryAudit";
import AccountReconciliation from "./componets/pages/industries/AccountReconciliation";
import PaymentPosting from "./componets/pages/industries/PaymentPosting";
import Blog from "./componets/pages/Blog";
import BlogDetail from "./componets/pages/BlogDetail";
import Credentialing from "./componets/pages/industries/Credentialing";
import { useState } from "react";
import useGoogleAnalytics from "./useGoogleAnalytics";
import SEOHandler from "./SEOHandler";
function App() {
  const [blogSearchQuery, setBlogSearchQuery] = useState('');

  useGoogleAnalytics();

  return (
    <>
      <Navbar
        blogSearchQuery={blogSearchQuery}
        onBlogSearchChange={setBlogSearchQuery}
      />

      {/* 🔴 THIS LINE IS IMPORTANT */}
      <SEOHandler />

      <Routes>
        <Route path="/" element={<Section />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />

        {/* Services */}
        <Route path="/services/nurse-practitioners" element={<NursePractitioners />} />
        <Route path="/services/mental-health" element={<MentalHealth />} />
        <Route path="/services/chiro" element={<Chiro />} />
        <Route path="/services/family-medicine" element={<FamilyMedicine />} />
        <Route path="/services/internal-medicine" element={<InternalMedicine />} />
        <Route path="/services/pt" element={<PT />} />

        {/* Industries */}
        <Route path="/industries/accounts-receivable" element={<AccountsReceivable />} />
        <Route path="/industries/denial-management" element={<DenialManagement />} />
        <Route path="/industries/charge-entry-audit" element={<ChargeEntryAudit />} />
        <Route path="/industries/account-reconciliation" element={<AccountReconciliation />} />
        <Route path="/industries/payment-posting" element={<PaymentPosting />} />
        <Route path="/industries/credentialing" element={<Credentialing />} />

        {/* Blog */}
        <Route
          path="/blog"
          element={
            <Blog
              searchQuery={blogSearchQuery}
              onSearchChange={setBlogSearchQuery}
            />
          }
        />
        <Route path="/blog/:id" element={<BlogDetail />} />
      </Routes>

      <Footer />
    </>
  );
}

export default App;
